module.exports = __webpack_public_path__ + "static/media/homem_r2_c3.8a74f142.jpg";